<!-- 手机登录，注册，修改密码  -->
<template>
  <div class="PhoneLogin-Component">
    <!-- <button class="btn-back" @click="back">{{ $t('lang115') }}</button> -->
    <h6
      :class="['title-login', { 'title-login-small': $i18n.locale === 'ru' }]"
    >
      {{ $t(formTitle) }}
    </h6>

    <div class="login-form-wrapper">
      <div v-if="activeTab < 2" class="tab-login-sign">
        <button
          v-for="(tab, index) in tabList"
          :key="index"
          :class="[
            'tab-login-sign__item',
            { 'tab-login-sign__item--active': activeTab === index }
          ]"
          @click="activeTab = index"
        >
          {{ tab.txt }}
        </button>
      </div>
      <!-- 0 登录 -->
      <login-form v-show="activeTab === 0" @go-other-form="changeActiveTab" />
      <!-- 1 注册 2 注册设置密码(其实没用到2,可废弃)-->
      <register-form
        v-if="activeTab === 1 || activeTab === 2"
        :register-phone="registerPhone"
      />
      <!-- 3 忘记密码 -->
      <reset-password-form v-if="activeTab === 3" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import LoginForm from './PhoneLogin-LoginForm';
import RegisterForm from './PhoneLogin-RegisterForm';
import ResetPasswordForm from './PhoneLogin-ResetPasswordForm';

export default {
  components: {
    LoginForm,
    RegisterForm,
    ResetPasswordForm
  },
  props: {
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    this.tabList = [{ txt: 'Log in' }, { txt: 'Sign up' }];
    return {
      activeTab: 0,
      // 用于 back 回退
      prevActiveTab: '',
      // 用户登录后提示未注册，从登录跳到注册带过去到手机号
      registerPhone: ''
    };
  },
  computed: {
    formTitle() {
      const { activeTab } = this;
      if (activeTab === 1) return 'lang105';
      if (activeTab === 2) return 'lang170';
      if (activeTab === 3) return 'lang171';

      return 'lang107';
    }
  },
  watch: {
    type: {
      handler(val) {
        if (val === 2) {
          this.activeTab = 1;
        }
      },
      immediate: true
    },
    activeTab: {
      handler(val) {
        this.$emit('activeTabChange', val);
      },
      immediate: true
    }
  },
  methods: {
    // back() {
    //   const { prevActiveTab } = this;
    //   if (prevActiveTab !== '') {
    //     this.activeTab = prevActiveTab;
    //     this.prevActiveTab = '';
    //   } else {
    //     this.$emit('back');
    //   }
    // },
    changeActiveTab(tab, registerPhone = '') {
      const { activeTab } = this;
      this.prevActiveTab = activeTab;
      this.activeTab = tab;

      if (tab === 1) {
        this.registerPhone = registerPhone;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-back {
  position: relative;
  display: inline-block;
  top: 15px;
  left: 15px;
  margin-bottom: 15px;
  color: #8ba8b4;

  &::before {
    content: '';
    display: block;
    float: left;
    width: 12px;
    height: 12px;
    margin-top: 2px;
    margin-right: 8px;
    border: 2px solid #8ba8b4;
    border-right: 0;
    border-bottom: 0;
    transform: rotate(-45deg);
  }
}

.title-login {
  margin: 24px auto;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #2f3033;
  line-height: 28px;

  &.title-login-small {
    margin: 12px auto;
  }
}

.login-form-wrapper {
  width: 300px;
  text-align: center;
  margin: auto;
}

.tab-login-sign {
  overflow: hidden;

  .tab-login-sign__item {
    float: left;
    width: 50%;
    text-align: center;
    border-bottom: 2px solid #e1e3e6;
    font-size: 14px;
    font-weight: 400;
    color: #8a8f99;
    line-height: 32px;

    &--active,
    &:hover {
      font-weight: 600;
      color: #00ddcc;
      border-bottom: 2px #00ddcc solid;
    }
  }
}
</style>
